<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml">
        <div v-for="page in totalPages" :key="page" class="mx-5 my-4">
          <div class="pdf-item mb-3 d-flex text-xs justify-content-between">
            <div>
              <img
                src="../assets/gunter_Logo-bg.png"
                alt="Logo"
                style="flex: none;"
                height="30"
                width="30"
              />
              <h4
                class="text-sm"
              >
                {{ paginatedData(page-1).shipperInfo.firstName.toUpperCase() }}
                {{ paginatedData(page-1).shipperInfo.lastName.toUpperCase() }}
                <br/>
                {{ paginatedData(page-1).shipperInfo.address.toUpperCase() }}
                <br/>
                {{ paginatedData(page-1).shipperInfo.city.toUpperCase() }},
                {{ paginatedData(page-1).shipperInfo.state.toUpperCase() }}
                {{ paginatedData(page-1).shipperInfo.zipCode }}
                <br>
                {{ paginatedData(page-1).shipperInfo.phone }}
                <br>
                {{ paginatedData(page-1).shipperInfo.email }}
              </h4>
            </div>
            <div class="text-xl font-weight-bold">
              <div>
                Customer Invoice
              </div>
            </div>
          </div>
          <div class="pdf-item d-flex text-sm justify-content-between">
            <div>
                SERVICES BILLLED TO:
                <h4
                class="text-sm"
                >
                {{paginatedData(page-1).consigneeInfo.firstName.toUpperCase()}}
                {{paginatedData(page-1).consigneeInfo.lastName.toUpperCase()}}
                <br/>
                {{paginatedData(page-1).consigneeInfo.address.toUpperCase()}}
                <br/>
                {{paginatedData(page-1).consigneeInfo.city.toUpperCase()}},
                {{paginatedData(page-1).consigneeInfo.state.toUpperCase()}}
                {{paginatedData(page-1).consigneeInfo.zipCode}}
                <br/>
                Tel: {{paginatedData(page-1).consigneeInfo.phone}}
                </h4>
            </div>
            <div>
              <table class="table table-bordered text-xs w-100" style="line-height: 0;">
                  <tr>
                    <th>ACCOUNT NUMBER</th>
                    <th>NUMBER</th>
                  </tr>
                  <tr>
                    <td>
                    </td>
                    <td>
                    {{ paginatedData(page-1).billOfLading }}
                    </td>
                  </tr>
                  <tr>
                    <th>DATE</th>
                    <th>FILE</th>
                  </tr>
                  <tr>
                    <td>
                    </td>
                    <td>
                    </td>
                  </tr>
                  <tr>
                    <th>DUE DATE</th>
                    <th>REFERENCE</th>
                  </tr>
                  <tr>
                    <td>
                    </td>
                    <td>
                    </td>
                  </tr>
                   <tr>
                    <th>TERMS</th>
                    <th>PO</th>
                  </tr>
                  <tr>
                    <td>
                    </td>
                    <td>
                    </td>
                  </tr>
                </table>
            </div>
          </div>
          <div class="pdf-item mb-2">
            <table class="table table-bordered text-sm w-100" style="line-height: 0;">
              <tr>
                <th colspan="2">CARRIER</th>
                <th>MASTER</th>
                <th>HOUSE</th>
              </tr>
              <tr>
                <td colspan="2">
                </td>
                <td>
                </td>
                <td>
                </td>
              </tr>
              <tr>
                <th>ARRIVAL DATE</th>
                <th>DEPARTURE DATE</th>
                <th>SHIPPER</th>
                <th>ORIGIN/DESTINATION</th>
              </tr>
              <tr>
                <td>
                </td>
                <td>
                </td>
                <td>
                  {{ paginatedData(page-1).shipper.toUpperCase()}}
                </td>
                <td>
                   {{paginatedData(page-1).shipperInfo.airportCode.toUpperCase()}}/
                   {{paginatedData(page-1).consigneeInfo.airportCode.toUpperCase()}}
                </td>
              </tr>
              <tr>
                <th>PIECES</th>
                <th>WEIGHT</th>
                <th>CONSIGNEE</th>
                <th>VOLUME</th>
              </tr>
              <tr>
                <td>
                  {{ paginatedData(page-1).qty}}
                </td>
                <td>
                   {{ paginatedData(page-1).weight}}
                </td>
                <td>
                   {{ paginatedData(page-1).consignee.toUpperCase()}}
                </td>
                <td>
                   {{ paginatedData(page-1).volume}}
                </td>
              </tr>
               <tr>
                <th>DATE OF ENTRY</th>
                <th>ENTRY NUMBER</th>
                <th colspan="2">DESCRIPTION</th>
              </tr>
              <tr>
                <td>
                </td>
                <td>
                </td>
                <td colspan="2">
                </td>
              </tr>
            </table>
          </div>
          <div class="pdf-item d-flex text-sm justify-content-between">
            <div>
              <table class="table-bordered text-sm text-center w-100"
              style="line-height: 1;">
                  <tr v-for="(payment) in paginatedPayments(page-1)"
                    :key="payment.id">
                    <td height="20px" width="300px">
                      {{ payment.paymentMethod ? payment.paymentMethod.toUpperCase() : '' }}
                    </td>
                    <td height="20px" width="300px">{{ payment.amount }}</td>
                  </tr>
              </table>
            </div>
            <div>
              <div class="text-xs text-left">
               Payment Received...
              </div>
              <div class="text-xs text-left">
               Cash ${{ paginatedData(page-1).totalpayment}}
              </div>
              <div class="text-xs text-left">
               Balance ${{ paginatedData(page-1).outstandingBalance}}
              </div>
              <table class="table table-bordered text-xs text-left w-100" style="line-height: 0;">
                <tr>
                  <th colspan="4">SUBTOTAL</th>
                </tr>
                <tr>
                  <td colspan="4">
                    USD {{ paginatedData(page-1).totalpayment}}
                  </td>
                </tr>
                <tr>
                  <th colspan="4">TAX</th>
                </tr>
                <tr>
                  <td colspan="4">
                  </td>
                </tr>
                <tr>
                  <th colspan="4">TOTAL</th>
                </tr>
                <tr>
                  <td colspan="4">
                    USD {{ paginatedData(page-1).totalpayment}}
                  </td>
                </tr>
              </table>
              <div v-if="paginatedData(page-1).outstandingBalance === 0"
              class="text-2xl text-center font-weight-bold">
                PAID
              </div>
            </div>
          </div>

          <div class="pdf-item mb-2">
            <table class="table table-bordered text-xs w-100">
                <tr>
                  <th>REMARKS</th>
                </tr>
                <tr>
                <td>
                  <div class="text-xs">
                  </div>
                  <div class="text-xs">
                    CREATED BY:
                    {{ currentUser.firstName.toUpperCase() }}
                    {{ currentUser.lastName.toUpperCase() }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="page < totalPages" class="html2pdf__page-break" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'CustomerInvoice',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      size: 20,
      travelModes: [
        { value: null, text: '' },
        { value: 'oceanDirect', text: 'Ocean Direct' },
        { value: 'oceanTranshipment ', text: 'Ocean Transshipment' },
        { value: 'air', text: 'Air' },
        { value: 'ground', text: 'Ground' },
      ],
    };
  },
  computed: {
    totalShipment() {
      let shipment = [];
      this.response.items.container.forEach((container) => {
        container.item.forEach((shipments) => {
          shipment = shipment.concat(shipments);
        });
      });
      return shipment;
    },
    totalPages() {
      const pages = this.totalShipment.length;
      if (pages === 0) {
        return 1;
      }
      return pages;
    },
  },
  methods: {
    paginatedData(page) {
      const paginated = this.totalShipment[page];
      console.log(paginated);
      if (paginated) {
        return paginated;
      }
      return {
        shipper: '',
        shipperInfo: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          country: '',
          zipCode: '',
          email: '',
          phone: '',
          aesITN: '',
          airportCode: '',
        },
        consignee: '',
        consigneeInfo: {
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          country: '',
          zipCode: '',
          email: '',
          phone: '',
          aesITN: '',
          airportCode: '',
        },
      };
    },
    paginatedPayments(page) {
      const payments = this.totalShipment[page];
      const paginated = payments?.payments || [];
      while (paginated.length < this.size) {
        paginated.push([]);
      }
      return paginated;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 600,
          scale: 2,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
  // margin-bottom: 5px;
  margin-bottom: 1px;
}
.table {
  margin-bottom: -0.8px;
}

.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.smalltext {
  font-size: 0.55rem;
  line-height: .8rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}
</style>
